import React, { useEffect, useRef, memo, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useOnUpdate } from 'js/customHooks'
import "styles/main/Charts.sass"
import "styles/main/Observations.sass"
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import { fetchPlots } from 'js/fetchers'



export default function Observations() {
  const {zone, universe} = useSelector((state) => state);
  const dispatch = useDispatch();


  useEffect(() => { 
      console.log('fetch Observations')
  });

  return (
      <div id="observationsCharts">
        <SimpleBar autoHide={false} style={{ height: "100%" }}>
          <div id="obsB" title="Back to metrics" onClick={() => {dispatch({ type: 'SET_OBSERVATIONS', payload: false})}}></div>
          <div id="charts">
            <iframe class="dynChart" src={"https://pqd.mercator-ocean.fr/charts/observations.html?tipo=sat&universe="+universe.toLowerCase()+"&area="+zone}/>
            <iframe class="dynChart" src={"https://pqd.mercator-ocean.fr/charts/observations.html?tipo=insitu&universe="+universe.toLowerCase()+"&area="+zone}/>
          </div>
        </SimpleBar>
      </div>
    )
}